//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    data() {
            return {

            }
        },
        methods: {
            send() {
                var askSpan = document.createElement('span');
                var askLi = document.createElement('li');
                var Ul = document.getElementsByClassName('msg')[0];
                askLi.classList.add("ask");
                Ul.appendChild(askLi);
                askLi.appendChild(askSpan);
                askSpan.innerText = document.getElementsByTagName('input')[0].value;
                // "http://www.tuling123.com/openapi/api?key=f34ac5e4a62f423fb7638f65ecc97e4d&info=" + this.ask
                var self = this;
                axios.get('http://www.tuling123.com/openapi/api?key=f34ac5e4a62f423fb7638f65ecc97e4d', {
                        params: {
                            info: document.getElementsByTagName('input')[0].value
                        }
                    })
                    .then(function(response) {
                        //self.answer = response.data;
                        var answerSpan = document.createElement('span');
                        var answerLi = document.createElement('li');
                        Ul.appendChild(answerLi);
                		answerLi.classList.add("answer");
                        answerLi.appendChild(answerSpan);
                        answerSpan.innerText = response.data.text;
                        document.getElementsByTagName('input')[0].value = "";
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        }
}



// WEBPACK FOOTER //
// ./src/views/connection.vue